export enum AuthenticatorObjectType {
    User = 0,
    Group = 1,
    Account = 2
}